/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import CampaignModel, { CampaignRestartModes, CampaignType } from 'cio/models/campaign';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { isPresent } from '@ember/utils';
import { ConditionType } from 'cio/utils/condition-types';

export interface CampaignsTriggerSetupFiltersArgs {
  campaign: CampaignModel;
  type: CampaignType;
  filters: Record<string, unknown>[];
  restartMode: string;
  updateFilters: (conditions: Record<string, unknown>[]) => unknown;
  maxSegmentCountBeforeThreshold: number;
  preferFilterOverCondition?: boolean;
  sidebarAddConditionDescription?: string;
}

export default class CampaignsTriggerSetupFilters extends Component<CampaignsTriggerSetupFiltersArgs> {
  @service analytics!: AnalyticsService;

  readonly conditionTypes = Object.freeze([ConditionType.Segments, ConditionType.SegmentsNegatable]);

  get isCampaignReEntrant() {
    return this.args.restartMode !== CampaignRestartModes.None && this.args.type === CampaignType.Behavioral;
  }

  get isFilterDisabled() {
    return !isPresent(this.args.filters) && this.isCampaignReEntrant;
  }

  @action
  trackSegmentCreationStartedFrom(source: string) {
    this.analytics.track('segment', 'creation_started', { source });
  }
}
